var _ellipse, _path, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadgeneration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#060C23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0435 82.1359C89.8398 77.3678 93.3621 71.8029 95.6092 65.8645M97.3362 60.226C97.8037 58.2544 98.1392 56.2578 98.3427 54.2503C98.494 52.7578 98.5723 51.2593 98.5777 49.7605",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5516,
    cy: 38.4838,
    rx: 32.9104,
    ry: 32.9104,
    fill: "#2E293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1679 47.3501L51.853 51.099L55.5381 47.3501C62.2041 45.6667 67.1449 39.542 67.1449 32.2472C67.1449 23.6511 60.3028 16.6906 51.853 16.6906C43.4031 16.6906 36.561 23.6511 36.561 32.2472C36.561 39.5539 41.5019 45.6786 48.1679 47.3501ZM51.853 19.4366C58.8124 19.4366 64.4574 25.1793 64.4574 32.2591C64.4574 39.339 58.8124 45.0697 51.853 45.0697C44.8936 45.0697 39.2486 39.3271 39.2486 32.2472C39.2486 25.1674 44.8936 19.4366 51.853 19.4366Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8532 43.3982C55.9491 43.3982 59.5168 41.1178 61.3945 37.7272V36.378C61.3945 35.6498 61.0073 34.9812 60.3735 34.635C59.6576 34.241 54.8928 31.4592 54.8928 31.4592C54.1535 32.462 53.4258 33.1784 52.2875 33.7395C52.0293 33.7276 51.7593 33.7276 51.5011 33.7395C50.3628 33.1784 49.6351 32.474 48.8958 31.4592L43.4034 34.635C42.7696 34.9812 42.3823 35.6498 42.3823 36.378V37.8585C44.2835 41.1775 47.8161 43.3982 51.8532 43.3982Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7965 45.1429C58.9515 45.1429 64.7518 39.3528 64.7518 32.2103C64.7518 25.0678 58.9515 19.2777 51.7965 19.2777C44.6416 19.2777 38.8413 25.0678 38.8413 32.2103C38.8413 39.3528 44.6416 45.1429 51.7965 45.1429Z",
    fill: "#22FFAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7965 45.1439C56.3151 45.1439 60.2937 42.8337 62.6112 39.3311C60.5374 35.4929 56.4712 32.8839 51.7965 32.8839C47.1203 32.8839 43.0557 35.4929 40.9819 39.3311C43.2994 42.8337 47.278 45.1439 51.7965 45.1439Z",
    fill: "#243CBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3272 30.1605C57.2767 28.2145 57.2767 25.0593 55.3272 23.1132C53.3778 21.1672 50.2171 21.1672 48.2676 23.1132C46.3181 25.0593 46.3181 28.2145 48.2676 30.1605C50.2171 32.1066 53.3778 32.1066 55.3272 30.1605Z",
    fill: "#243CBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4757 51.3976C26.8067 51.3976 30.3177 47.8928 30.3177 43.5694C30.3177 39.246 26.8067 35.7411 22.4757 35.7411C18.1447 35.7411 14.6338 39.246 14.6338 43.5694C14.6338 47.8928 18.1447 51.3976 22.4757 51.3976Z",
    fill: "#243CBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4757 51.3976C26.8067 51.3976 30.3177 47.8928 30.3177 43.5694C30.3177 39.246 26.8067 35.7411 22.4757 35.7411C18.1447 35.7411 14.6338 39.246 14.6338 43.5694C14.6338 47.8928 18.1447 51.3976 22.4757 51.3976Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4773 51.3998C25.2126 51.3998 27.6211 50.0014 29.024 47.881C27.7686 45.5576 25.3071 43.9782 22.4773 43.9782C19.6465 43.9782 17.186 45.5576 15.9307 47.881C17.3335 50.0014 19.742 51.3998 22.4773 51.3998Z",
    fill: "#060C23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6126 42.3293C25.7925 41.1515 25.7925 39.2419 24.6126 38.0641C23.4328 36.8863 21.5198 36.8863 20.3399 38.0641C19.1601 39.2419 19.1601 41.1515 20.34 42.3293C21.5198 43.5071 23.4328 43.5071 24.6126 42.3293Z",
    fill: "#060C23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2938 54.7127L24.5479 52.4587C26.1333 52.0517 27.647 51.2185 28.8964 49.969C32.5519 46.3135 32.6023 40.4375 29.009 36.8443C25.4074 33.2427 19.5314 33.2931 15.876 36.9486C12.2205 40.604 12.1701 46.48 15.7634 50.0733C16.9916 51.3015 18.4829 52.1006 20.0698 52.4887L22.2938 54.7127ZM17.0212 38.0938C20.035 35.0799 24.8731 35.0384 27.8357 38.001C30.7983 40.9636 30.7568 45.8017 27.7429 48.8155C24.7291 51.8294 19.891 51.8709 16.9284 48.9083C13.9658 45.9457 14.0073 41.1076 17.0212 38.0938Z",
    fill: "#D7DEEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3371 51.398C85.6681 51.398 89.179 47.8932 89.179 43.5697C89.179 39.2463 85.6681 35.7415 81.3371 35.7415C77.0061 35.7415 73.4951 39.2463 73.4951 43.5697C73.4951 47.8932 77.0061 51.398 81.3371 51.398Z",
    fill: "#243CBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3371 51.398C85.6681 51.398 89.179 47.8932 89.179 43.5697C89.179 39.2463 85.6681 35.7415 81.3371 35.7415C77.0061 35.7415 73.4951 39.2463 73.4951 43.5697C73.4951 47.8932 77.0061 51.398 81.3371 51.398Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3382 51.4002C84.0735 51.4002 86.482 50.0017 87.8848 47.8814C86.6295 45.558 84.168 43.9785 81.3382 43.9785C78.5074 43.9785 76.0468 45.558 74.7915 47.8814C76.1944 50.0017 78.6028 51.4002 81.3382 51.4002Z",
    fill: "#060C23"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4744 42.3296C84.6543 41.1518 84.6543 39.2422 83.4744 38.0644C82.2946 36.8866 80.3816 36.8866 79.2018 38.0644C78.0219 39.2422 78.0219 41.1518 79.2018 42.3296C80.3816 43.5074 82.2946 43.5074 83.4744 42.3296Z",
    fill: "#060C23"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1547 54.7118L83.4087 52.4577C84.9941 52.0508 86.5078 51.2175 87.7573 49.9681C91.4127 46.3126 91.4631 40.4366 87.8698 36.8434C84.2683 33.2418 78.3923 33.2922 74.7368 36.9476C71.0813 40.6031 71.0309 46.4791 74.6242 50.0724C75.8524 51.3006 77.3437 52.0996 78.9307 52.4878L81.1547 54.7118ZM75.882 38.0928C78.8959 35.079 83.7339 35.0375 86.6965 38.0001C89.6591 40.9627 89.6176 45.8007 86.6038 48.8146C83.5899 51.8284 78.7518 51.87 75.7892 48.9074C72.8267 45.9448 72.8682 41.1067 75.882 38.0928Z",
    fill: "#D7DEEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54421 61.4897C6.13331 59.3176 5.88027 57.1218 5.78488 54.9209C5.6176 51.0613 5.93509 47.1857 6.73624 43.393",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_29069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#060C23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_29069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4961 112.196C37.053 111.968 25.6099 99.9183 25.6506 85.4897L25.7358 60.466L38.5117 60.4667L38.4086 85.6037C38.387 92.9674 44.1513 99.2175 51.5123 99.4251C59.1437 99.6479 65.4534 93.5125 65.4606 85.9278L65.545 60.4843L78.3209 60.485L78.2365 85.9285C78.2179 100.557 66.175 112.404 51.4961 112.196Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4962 112.197L51.5124 99.4251C59.1438 99.6479 65.4535 93.5126 65.4607 85.9279L65.5451 60.4843L78.321 60.485L78.2366 85.9286C78.218 100.557 66.1751 112.404 51.4962 112.197Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5981,
    y: 60.328,
    width: 12.8302,
    height: 6.7761,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.4888,
    y: 60.328,
    width: 12.8302,
    height: 6.7761,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadgeneration);
export default __webpack_public_path__ + "static/media/lead generation.9cdacff69de0e039112e99e04bc5e0bd.svg";
export { ForwardRef as ReactComponent };